import { getErrorMessage } from "../../../../../helper/getResponseMessage";
import axios from "../../../../../util/axiosconfig";
import { SORT_FILTER } from "../../../../../util/constants";
import { showError } from "../../../../../util/ShowStatus";

export const fetchMyLogsData = async (
  props: any
) => {
  try {
    props.setMyLogsDataLoading(true);
    const params: any = {
      size: props.size,
      page: props.page,
      sortField: props.sortFilter.sortField,
      sortOrder:
        props.sortFilter.sortOrder === true
          ? SORT_FILTER.ASC
          : SORT_FILTER.DESC,
    };
    if (props.filters) {
      params.startDate = props.filters.startDate;
      params.endDate = props.filters.endDate;
      params.vehicleID = props.filters?.vehicleRegistration?.vehicleID;
      props.filters.name !== "" && (params.name = props.filters.name);
      props.filters.status && (params.status = props.filters.status);
      props.filters.project && (params.projectID = props.filters.project.projectID);
      const response = await axios.get("tl-user/time-log-list", { params });
      props.setMyLogsData(response.data.result);
      props.setTotalRecords(response.data.totalRecords);
      props.setMyLogsDataLoading(false);
    }
  } catch (err) {
    const error = getErrorMessage(err);
    props.setMyLogsDataLoading(false);
    showError(error, props.toast);
  }
};
